
























import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { AuditOption } from '~/models/audit/option'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<AuditOption[]>,
      required: true
    },
    limit: {
      type: Number,
      required: false,
      default: 5
    },
    checkColorClass: {
      type: String,
      required: false,
      default: 'tw-text-primary'
    },
    noLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    dotsClass: {
      type: String,
      required: false,
      default: '!tw-mt-2'
    }
  },
  setup(props) {
    const { options, limit, noLimit } = toRefs(props)
    const optionsToShow = computed(() => {
      if (noLimit.value) {
        return options.value
      }
      return options.value.slice(0, limit.value)
    })
    return { optionsToShow, faCheck }
  }
})
